
    import { defineComponent, PropType } from 'vue'
    import Dialog from 'primevue/dialog'
    import DataTable from 'primevue/datatable'
    import Column from 'primevue/column'
    import { FilterOperator } from 'primevue/api'
    import { filterDefault } from '@/helpers/commons/filterHelper'
    import { iAttribute } from '../UsersManagement'
    import userAttributesLovValueDialogDescriptor from './UserAttributesLovValueDialogDescriptor.json'
    import { AxiosResponse } from 'axios'

    export default defineComponent({
        name: 'lovs-value-dialog',
        components: { Dialog, DataTable, Column },
        emits: ['closeDialog', 'saveLovValues'],
        props: {
            attribute: {
                type: Object as PropType<iAttribute>,
                required: true
            },
            dialogVisible: Boolean,
            selection: Object as PropType<any>
        },
        watch: {
            attribute() {
                if (!this.attribute) return
                this.loadAttributeValue()
                this.selectionMode = this.attribute.multivalue ? 'multiple' : 'single'
                this.selectedLovValues = this.attribute.multivalue ? [] : {}
            }
        },
        created() {
            this.loadAttributeValue()
        },
        data() {
            return {
                selectedLovValues: [] as Array<any> | Object,
                lovValues: [
                    { id: 1, value: 'Bla bla' },
                    { id: 2, value: 'ohoooo' }
                ],
                userAttributesLovValueDialogDescriptor: userAttributesLovValueDialogDescriptor,
                selectionMode: 'multiple',
                filters: {
                    global: [filterDefault],
                    value: {
                        operator: FilterOperator.AND,
                        constraints: [filterDefault]
                    }
                } as Object
            }
        },
        methods: {
            async loadAttributeValue() {
                if (this.attribute?.lovId) {
                    await this.$http.get(process.env.VUE_APP_RESTFUL_SERVICES_PATH + `2.0/lovs/${this.attribute.lovId}/preview`).then((response: AxiosResponse<any>) => {
                        this.lovValues = response.data.map((lovValue, index) => {
                            return { value: lovValue, id: index }
                        })
                        this.loadSelectedValues()
                    })
                }
            },
            loadSelectedValues() {
                if (this.attribute.multivalue) {
                    this.selectedLovValues = []
                    if (Array.isArray(this.selection)) {
                        const values = [] as Array<any>
                        this.selection.forEach((selValue) => {
                            const ind = this.lovValues.findIndex((lovValue) => lovValue.value == selValue)
                            if (ind >= 0) {
                                values.push(this.lovValues[ind])
                            }
                        })
                        this.selectedLovValues = values
                    }
                } else {
                    this.selectedLovValues = {}
                    const ind = this.lovValues.findIndex((lovValue) => lovValue.value == this.selection)
                    if (ind >= 0) {
                        this.selectedLovValues = this.lovValues[ind]
                    }
                }
            },
            closeDialog() {
                this.$emit('closeDialog')
            },
            handleSubmit() {
                this.$emit('saveLovValues', this.selectedLovValues)
            }
        }
    })
